export default __webpack_public_path__ + "static/media/TransplantRecipientIcon.36fcbb6a.svg";